import { render } from "./DeliveryPickup.vue?vue&type=template&id=ce9af5b0&scoped=true"
import script from "./DeliveryPickup.vue?vue&type=script&lang=js"
export * from "./DeliveryPickup.vue?vue&type=script&lang=js"

import "./DeliveryPickup.vue?vue&type=style&index=0&id=ce9af5b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce9af5b0"]])

export default __exports__